import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

// The DELETE endpoint answers 500 (not 404) when nothing matches — a possible,
// non-exceptional outcome for already-deleted entities. Errors propagate as-is and
// the mutation layer must not retry them.
export const deleteExclusionAreas = async ({ entities }) => {
  const ids = entities.map(entity => entity.id)
  const response = await apiClient.delete(endpoints.exclusionAreas, { data: { ids } })
  return unwrapVoid(response)
}
